import type { LinkEntity as LinkEntityProps } from "components/base-entity-link/types";

type Item = {
  isBold?: boolean;
  isLargeSpacing?: boolean;
} & LinkEntityProps;

export type FooterMenuData = Item[];

export const footerMenuData: FooterMenuData[] = [
  [
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      isLargeSpacing: true,
      name: "Video",
      routeType: "Page",
      urlAlias: "/posties/video",
    },
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      isLargeSpacing: true,
      name: "ePaper",
      routeType: "Page",
      urlAlias: "/epaper",
    },
  ],
  [
    {
      entityId: "",
      isLargeSpacing: true,
      name: "Subscribe",
      urlAlias: "https://subscribe.scmp.com/posties",
    },
    {
      entityId: "",
      entityUuid: "",
      isLargeSpacing: true,
      name: "About us",
      routeType: "Static",
      urlAlias: "/page/3227689/about-posties",
    },
    {
      entityId: "",
      entityUuid: "",
      isLargeSpacing: true,
      name: "Contact us",
      routeType: "Static",
      urlAlias: "/page/3227701/contact-posties",
    },
    {
      entityId: "800172",
      entityUuid: "d1c18b93-cb6c-48a2-bf84-7c2acb96d4cc",
      isLargeSpacing: true,
      name: "Privacy Policy",
      routeType: "Page",
      urlAlias: "/privacy-policy",
    },
    {
      entityId: "800173",
      entityUuid: "c18b91b9-6e24-45dc-ba05-974848666e4b",
      isLargeSpacing: true,
      name: "Terms & Conditions",
      routeType: "Page",
      urlAlias: "/terms-conditions",
    },
  ],
];
